module.exports = __webpack_public_path__ + "static/rcac-friendship-form-e0bfe45345f31026c300a828c7c64c9b.pdf";